// Prefer error.error (OAuth code) over error.message (description) since
// Auth0 OAuthError sets error.error = 'invalid_grant' while message is the
// human-readable description ("Unknown or invalid refresh token.").
const SESSION_EXPIRED_AUTH_ERRORS = [
  'login_required',
  'consent_required',
  'invalid_grant',
  'invalid refresh token',
  'missing_refresh_token',
  'access_denied',
  'forbidden',
];

export const isSessionExpiredAuthError = (error: unknown): boolean => {
  const oauthError = (error as { error?: string })?.error;
  const message = (error as Error)?.message;
  const haystack = `${oauthError || ''} ${message || ''}`.toLowerCase();

  return SESSION_EXPIRED_AUTH_ERRORS.some((code) => haystack.includes(code));
};
